export const PROJECTS = [
  {
    id: 0,
    name: "Hobby Tabletop RPG Site",
    image: "assets/images/pergasha-portfolio.png",
    live: "https://ormandis.hopskipcode.com/home.html",
    github:
      "https://github.com/jesuisfrog/Pergasha-Website",

    description:
      "References for the D&D homebrew setting: Pergasha.",
    tech: "Technology used: Jquery, Vanilla Javascript, Bootstrap",
  },
  {
    id: 1,
    name: "Current Portfolio Site",
    image: "assets/images/portfolio.png",
    live: "https://jesuisfrog.com/",
    github:
      "https://github.com/jesuisfrog/jesuisfrog-portfolio",

    description:
      "This portfolio uses React-fluid-animation and React-spring libraries, so the viewers can draw and play with the cards.",
    tech: "Technology used: React JS",
  },
  {
    id: 2,
    name: "Foundry Virtual Tabletop Content",
    image: "assets/images/foundry-work.png",
    github:
      "https://github.com/jesuisfrog/Foundry-Work/blob/main/README.md",

    description:
      "Custom setting and modules for Foundry VTT.",
    tech: "Technology used: Vanilla Javascript, CSS, Handlebars",
  },
];
